import { Component, Inject, OnInit } from '@angular/core';
import { IAskForQuotation, IAskForQuotationProduct, IParseProduct, IQuotationProduct } from '../../models/quotations.models';
import { Observable, of, Subscription, tap } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { IProduct, IVariant } from 'src/app/features/produits/models/products.models';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/app.state';
import { Router } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
import { GetProductsCatalogCompanyById } from 'src/app/features/catalogs/store/catalogs.actions';
import { quantityValidator } from 'src/app/shared/validators/fields-validators';
import { EditAndSendQuotation, EditAndSendQuotationSuccess } from '../../store/quotations.actions';
import { environment } from 'src/environments/environment';
import { capitalize } from 'src/app/shared/utils/helpers';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from 'src/app/shared/common.service';
import { ProductCodeService } from 'src/app/core/services/product-code.service';
import { ICategory } from 'src/app/features/categories/models/categories.models';
import { ICurrency } from 'src/app/features/customers/models/customers.models';

export interface DataType {
  products: IParseProduct[];
  pricelist_id: number;
  quotation_id: number;
  location_id: number;
  currency?: ICurrency;
}

@Component({
  selector: 'app-edit-quotes',
  templateUrl: './edit-quotes.component.html',
  styleUrls: ['./edit-quotes.component.scss']
})
export class EditQuotesComponent implements OnInit {

  placeholder: string = 'assets/images/placeholder.png';
  totalquantity: number = 0;
  previousValue: number = 0;
  quotationProducts: IAskForQuotationProduct[] = [];
  filteredProducts: IAskForQuotationProduct[] = [];
  subscriptions: Subscription[] = [];
  productsForm!: FormGroup;
  form!: FormGroup;
  products$: Observable<IProduct[]> = of([]);
  products: IQuotationProduct[] = [];
  currentFilter: IQuotationProduct[] = [];
  nameControleProduct: FormControl = new FormControl();
  isFinalQuote: boolean = false;
  baseUrl = environment.BASE_URL_API;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DataType,
    private dialogRef: MatDialogRef<EditQuotesComponent>,
    private store: Store<AppState>,
    private actions$: Actions,
    private router: Router,
    private fb: FormBuilder,
    private translateService: TranslateService,
    private commonService: CommonService,
    public productCode: ProductCodeService
  )  {
    this.form = this.fb.group({
      minStock: [''],
      maxStock: [''],
      minPrice: [''],
      maxPrice: [''],
      brands: [''],
      categories: ['']
    });

    this.productsForm = this.fb.group({
    });
   }
   brands: { id: number | null; name: string }[] = [];
   categories: { id: number; name: string }[] = [];
  ngOnInit(): void {
    this.store.dispatch(GetProductsCatalogCompanyById({ locationId: this.data.location_id, catalogId: this.data.pricelist_id }));
    this.products$ = this.store.select((state) => state.catalogs.products);
    const sub1 = this.products$.subscribe(products => {
      this.products = products.map((p: IProduct) => {
        if (!this.brands.find((brand) => brand.id === p.brand!.id)) {
          if(p.brand!.id === null)
          {
            this.brands.push({id: null, name: this.translateService.instant('quotations_and_orders.without_brand')})
          }
          else{
            this.brands.push({ id: p.brand!.id, name: capitalize(p.brand!.name) });
          }
        }
        const categories = [...this.categories, ...p.categories!];

        const productCategories = Array.from(
          new Map(categories.map(category => [category.id, category])).values()
        );
        this.categories = productCategories;
          // Get currency-specific prices
          const selectedCurrencyId = this.data.currency?.id;
          const productPrices = selectedCurrencyId ? this.getPricesFromCurrency(p, selectedCurrencyId) : { sales_price: p.sales_price ?? null, final_price: p.final_price ?? 0 };
          const existingProduct = this.data.products.find((product: IParseProduct) => product.id === p.id);
          return {
            product_id: p.id!,
            name: p.name,
            discount: existingProduct ? existingProduct.discount : p.total_discount ?? 0,
            cost: p.cost,
            image: p.image,
            quantity: existingProduct ? existingProduct.quantity : p.min_qte ?? 0,
            initial_quantity: existingProduct ? existingProduct.quantity : p.min_qte ?? 0,
            sku: p.sku,
            erp_id: p.erp_id,
            stock: p.stock,
            price_unit: existingProduct ? existingProduct.price_unit : productPrices.sales_price ?? 0,
            increment: p.increment,
            max_qte: p.max_qte,
            min_qte: p.min_qte,
            checked: existingProduct ? true : false,
            brand_id: p.brand!.id,
            categories: p.categories!,
            final_price: existingProduct ? existingProduct.final_price! : (productPrices.final_price ?? 0),
            is_killing_stock: false,
            killing_stock_limit: undefined,
            is_owned: p.is_owned,
            status: p.status
          };
      }).sort((a, b) => (a.checked === b.checked) ? 0 : a.checked ? -1 : 1);

      this.brands.sort((first, second) => (first.name < second.name ? -1 : 1));
      this.categories.sort((first, second) => (first.name < second.name ? -1 : 1));

      const controls = Object.keys(this.productsForm.controls);
      controls.forEach(controlName => {
        this.productsForm.removeControl(controlName);
      });

      this.products.forEach((product: IQuotationProduct) => {
        this.productsForm.addControl(`quantity_${product.product_id}`, new FormControl({value: product.quantity, disabled: !product.checked}, [Validators.required, quantityValidator(product,this.translateService)]));
        this.productsForm.addControl(`final_price_${product.product_id}`, new FormControl({ value: product.final_price, disabled: !product.checked }, [Validators.required]));
      });
      // this.products.forEach((product: IProduct) => {
      //   this.brands.push({ id: product.brand!.id, name: product.brand!.name });
      //   this.categories.push({ id: product.category!.id, name: product.category!.name });
      // });
      this.applyFilter();
    });

    const sub2 = this.nameControleProduct.valueChanges.subscribe(() => this.applyFilter());
    const sub3 = this.actions$.pipe(
      ofType(EditAndSendQuotationSuccess),
      tap(() => {
        this.router.navigate(['quotations']);
        this.close();
      })).subscribe();

    this.subscriptions.push(sub1, sub2, sub3);
  }

  updateQuantity(event: Event, product: IQuotationProduct) {
    const quantity = +(event.target as HTMLInputElement).value;
    product.quantity = quantity;
  }

  updateDiscount(event: any, product: IQuotationProduct) {
    const input = event.target;
    const discount = input.value <= 0 ? 0 : input.value > 100 ? 100 : +input.value;
    input.value = discount;

    product.discount = discount;
    product.final_price = product.price_unit! * (1 - product.discount / 100);
  }

  updateFinalPrice(event: any, product: IQuotationProduct) {
    const input = event.target;
    const finalPrice = input.value <= 0 ? 0 : +input.value;
    input.value = finalPrice;

    product.final_price = finalPrice;
    product.discount = Number((100 - (finalPrice * 100 / product.price_unit!)).toFixed(2));
  }

  checkAllProducts(event: any) {
    const checked = event.checked;
    if(checked) {
      this.currentFilter.forEach((product: IQuotationProduct) => {
        if(product.checked) return;
        if ((((product.stock && product.stock.quantity >= product.min_qte!) && product.is_owned) || !product.is_owned) && product.status !== 'Draft') {
          product.quantity = product.initial_quantity!;
          this.productsForm.get(`quantity_${product.product_id}`)?.setValue(product.initial_quantity);
          this.productsForm.get(`quantity_${product.product_id}`)?.enable();
          this.productsForm.get(`final_price_${product.product_id}`)?.enable();
          product.checked = checked;
        }
      });
    }else{
      this.products.forEach((product: IQuotationProduct) => {
        this.productsForm.get(`quantity_${product.product_id}`)?.setValue(product.min_qte);
        this.productsForm.get(`quantity_${product.product_id}`)?.disable();
        this.productsForm.get(`final_price_${product.product_id}`)?.disable();
        product.checked = checked;
      })
    }
  }

  isAllChecked() {
    return (
      this.currentFilter.length > 0 &&
      this.currentFilter.every(
        (product) =>
          product.checked ||
          (product.status === 'Draft' || ((!product.stock || product.stock && product.stock.quantity < product.min_qte!) && product.is_owned))
      )
    );
  }

  productsSelected(): number {
    return this.products.filter((product: IQuotationProduct) => product.checked).length;
  }

  allProductsDisable(): boolean {
    return this.currentFilter.every((product: IQuotationProduct) => (product.status === 'Draft' || !product.stock || product.stock && product.stock.quantity < product.min_qte!));
  }

  totalQuantity(): number {
    return this.products.filter((product: IQuotationProduct) => product.checked).reduce((acc, product) => {
      return acc + product.quantity;
    }, 0);
  }

  totalPrice(): number {
    return this.products.filter((product: IQuotationProduct) => product.checked).reduce((acc, product) => {
      return acc + (product.final_price ? product.quantity * product.final_price : (product.quantity * (product.price_unit! * (1 - product.discount / 100)))) ;
    }, 0);
  }

  checkProduct(product: IQuotationProduct, event: any) {
    const checked = event.checked;
    if (checked) {
      product.quantity = product.initial_quantity!;
      this.productsForm.get(`quantity_${product.product_id}`)?.setValue(product.initial_quantity);
      this.productsForm.get(`quantity_${product.product_id}`)?.enable();
      this.productsForm.get(`final_price_${product.product_id}`)?.enable();
    } else {
      product.quantity = product.min_qte!;
      this.productsForm.get(`quantity_${product.product_id}`)?.setValue(product.min_qte);
      this.productsForm.get(`quantity_${product.product_id}`)?.disable();
      this.productsForm.get(`final_price_${product.product_id}`)?.disable();
    }
  }

  clearFilters() {
    this.form.reset({
      minStock: '',
      maxStock: '',
      minPrice: '',
      maxPrice: '',
      brands: '',
      categories: ''
    });
    this.applyFilter();
  }

  applyFilter() {
    const filters = this.form.value;

    this.currentFilter = this.products.filter(product => {
      const nameOrSkuMatches = !this.nameControleProduct.value ||
        product.name?.toLowerCase().includes(this.nameControleProduct.value?.toLowerCase()) ||
        product.sku?.toLowerCase().includes(this.nameControleProduct.value?.toLowerCase());

      const stockMatches = (!filters.minStock || product.stock?.quantity! >= +filters.minStock) &&
                           (!filters.maxStock || product.stock?.quantity! <= +filters.maxStock);

      const priceMatches = (!filters.minPrice || product.price_unit! >= +filters.minPrice) &&
                           (!filters.maxPrice || product.price_unit! <= +filters.maxPrice);

      const brandMatches = !filters.brands || product.brand_id === +filters.brands ||
      (product.brand_id === null && filters.brands === 'null');
      const categoryMatches = !filters.categories || product.categories?.some(cat => filters.categories.map((category: ICategory) => category.id).includes(cat.id));

      return nameOrSkuMatches && stockMatches && priceMatches && brandMatches && categoryMatches;
    });

  }

  isKillingStock(product: IQuotationProduct): boolean {
    if(product.checked && product.killing_stock_limit && product.killing_stock_limit > 0 && product.initial_quantity) {
      const is_killing_stock: boolean = (product.initial_quantity - product.quantity) < product.killing_stock_limit;
      return is_killing_stock;
    }
    else return false;
  }
  exceededStock(product: IQuotationProduct): number {
    if(product.checked && product.killing_stock_limit && product.initial_quantity ) {
      return product.killing_stock_limit - (product.initial_quantity - product.quantity);
    }
    else return 0;
  }

  SendQuotation(): void | boolean {
    if(this.products.filter(product => product.checked).length === 0){
      this.commonService.showToast(
        this.translateService.instant('Catalogs.selectedAtLeastProduct'),
        'WARNING'
      );
      return false
    }

    if(this.productsForm.invalid) {
      this.productsForm.markAllAsTouched();
      return false;
    }

    const product: IAskForQuotationProduct[] = this.products.filter(product => product.checked).map((product: IQuotationProduct) => {
      return {
        product_id: product.product_id,
        name: product.name,
        quantity: product.quantity,
        discount: product.discount,
        increment: product.increment,
        min_qte: product.min_qte,
        max_qte: product.max_qte,
        sku: product.sku,
        price_unit: product.price_unit,
        total_discount: product.discount,
        final_price: product.final_price
      }
    });


    const payload: IAskForQuotation = {
      pricelist_id: this.data.pricelist_id,
      is_final: this.isFinalQuote,
      products: product
    }

    this.store.dispatch(EditAndSendQuotation({ id: this.data.quotation_id!, quotation: payload }));
  }

  close() {
    this.dialogRef.close();
  }

    /**
   * Get prices from product currencies based on selected currency ID
   */
    private getPricesFromCurrency(product: IProduct, currencyId: number): { sales_price: number | null; final_price: number } {
      console.log(product.currencies);
      if (product.currencies && product.currencies.length > 0) {
        const currencyData = product.currencies.find(currency => currency.currency_id === currencyId);
        if (currencyData) {
          return {
            sales_price: currencyData.sales_price ?? null,
            final_price: currencyData.final_price ?? product.final_price ?? 0
          };
        }
      }
      // Fallback to default prices if currency not found
      return {
        sales_price: product.sales_price ?? 0,
        final_price: product.final_price ?? 0
      };
    }

  ngOnDestory() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
